<template>
    <div>
        <b-tabs
            class="portfolio-show-tab apprentice-tab"
            v-model="activeTab"
            nav-wrapper-class="tab-content-wrapper"
            content-class="portfolio-show-content"
            @input="updateTabIndex">
            <template #tabs-end>
                <div
                    class="apprentice-tab-buttons portfolio-show-tab-header"
                    v-if="shouldShowTab()">
                    <b-badge
                        class="badge-rating portfolio-rating"
                        v-if="hasRatingResult && activeTab === 1"
                        pill
                        variant="primary">
                        <i class="fas fa-fw fa-trophy"></i>{{ getResultValue }}
                    </b-badge>

                    <design-2021-portfolio-show-open-close-component
                        v-if="!$authUser.isStudent()"
                        :group-in="groupIn"
                        :project-in="projectIn">
                    </design-2021-portfolio-show-open-close-component>

                    <b-button
                        class="btn-medal btn-rate-portfolio-show"
                        v-if="projectIn.type_id === 2 && activeTab === 1 && portfolio.portfolio_rating"
                        v-b-modal="'portfolio-rating'"
                        variant="primary-icon">
                    </b-button>

                    <b-dropdown
                        class="ellipsis-nav portfolio-show-nav"
                        v-if="(canRate && projectIn.type_id !== 2) || (canEditTitle && projectIn.type_id !== 2)"
                        variant="primary"
                        no-caret
                        right
                        text="Right align"
                        toggle-class="portfolio-show-context-menu">
                        <template #button-content>
                            <i class="fas fa-ellipsis-v fa-fw"></i>
                        </template>
                        <b-dropdown-item
                            class="btn-edit btn-edit-portfolio-title"
                            v-b-modal="'portfolio-edit-title-modal'"
                            v-if="canEditTitle && project.type_id !== 2">
                            {{ $t('portfolio.adjust_title') }}
                        </b-dropdown-item>
                        <b-dropdown-item
                            class="btn-medal btn-rate-portfolio"
                            v-b-modal="'portfolio-rating'"
                            v-if="canRate">
                            {{ $t('portfolio.assess') }}
                        </b-dropdown-item>
                        <b-dropdown-item
                            class="btn-shopping-cart btn-portfolio-order"
                            v-if="project.type_id !== 2"
                            @click="onOrder">
                            {{ $t('portfolio.order') }}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>

                <design-2021-portfolio-show-rating-modal-component
                    v-if="canRate"
                    :rating-in="portfolio.portfolio_rating"
                    key-name="portfolio-rating"
                    :children-in="portfolio.categories"
                    :child-title="$t('portfolio.category_results')"
                    :title="$t('portfolio.portfolio_assessment')"
                    @save-rating="savePortfolioRating($event)">
                </design-2021-portfolio-show-rating-modal-component>

                <design-2021-portfolio-show-edit-title-component
                    :project-in="projectIn"
                    :can-edit-title="canEditTitle">
                </design-2021-portfolio-show-edit-title-component>
            </template>

            <b-tab
                :title="$t('portfolio.progress')"
                title-item-class="progress-tab">
                <design-2021-portfolio-show-progress-component
                    :portfolio-in="portfolioIn"
                    :project-id="projectIn.id"
                    :group-in="groupIn"
                    :roadmap-in="roadmapIn">
                </design-2021-portfolio-show-progress-component>
            </b-tab>

            <b-tab
                :title="$t('portfolio.assignments')"
                title-item-class="assignments-tab">
                <design-2021-portfolio-show-assignments-component
                    :portfolio-in="portfolioIn"
                    :project-id="projectIn.id"
                    :category-id="categoryId">
                </design-2021-portfolio-show-assignments-component>
            </b-tab>

            <b-tab
                title="Tools"
                title-item-class="tools-tab">
                <design-2021-portfolio-show-tools-component
                    :project-in="projectIn"
                    :group-in="groupIn"
                    :logs-in="logsIn"
                    :logs-by-time-in="logsbytimeIn"
                    :is-teacher="isTeacher"
                    :questionnaire="questionnaire"
                    :ratings="ratings"
                    :agenda-items="agendaItems"
                    :agenda-title="agendaTitle"
                    :is-student="isStudent"
                    :courses-in="coursesIn">
                </design-2021-portfolio-show-tools-component>
            </b-tab>

            <b-tab
                :title="$t('portfolio.messages')"
                title-item-class="messages-tab">
                <template v-slot:title>
                    {{ $t('portfolio.messages') }}
                    <span
                        class="notification-bubble paper-messages-count messages-count-bubble"
                        v-if="count !== 0">
                        {{ count }}
                    </span>
                </template>

                <design-2021-project-show-message-component
                    :project-type-id="projectIn.id"
                    :messages-in="messagesIn"
                    message-type="project"
                    :is-student="isStudent">
                </design-2021-project-show-message-component>
            </b-tab>

            <b-tab
                v-if="$authUser.isTeacher() && (projectIn.type_id === 1 || projectIn.type_id === 2)"
                :title="$t('common.edit')"
                title-item-class="messages-tab">
                <design-2021-portfolio-show-teacher-component
                    :project-in="projectIn"></design-2021-portfolio-show-teacher-component>
            </b-tab>

            <b-tab
                v-if="$authUser.isAdmin() && (projectIn.type_id === 1 || projectIn.type_id === 2)"
                title="Admin"
                title-item-class="messages-tab">
                <design-2021-portfolio-show-admin-component
                    :project-in="projectIn"></design-2021-portfolio-show-admin-component>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { CommonBus } from '../../../app';
import Design2021PortfolioShowTeacherComponent from './tabs/tools/design-2021-portfolio-show-teacher-component.vue';

export default {
    name: 'design-2021-portfolio-show-component',
    components: { Design2021PortfolioShowTeacherComponent },
    props: [
        'portfolioIn',
        'projectIn',
        'messagesIn',
        'groupIn',
        'logsIn',
        'logsbytimeIn',
        'isTeacher',
        'questionnaire',
        'ratings',
        'roadmapIn',
        'agendaItems',
        'agendaTitle',
        'isStudent',
        'categoryIdIn',
        'canEditTitle',
        'coursesIn',
    ],
    data() {
        return {
            activeTab: 1,
            portfolio: this.portfolioIn,
            count: this.projectIn.group.messages_count,
            project: this.projectIn,
            categoryId: this.categoryIdIn,
        };
    },
    methods: {
        getActiveTab() {
            let hasDeadlines = false;
            let hasAssignmentInProgress = false;

            if (this.portfolio && this.portfolio.categories.length > 0) {
                for (const category of this.portfolio.categories) {
                    if (category.assignments.length > 0) {
                        for (const assignment of category.assignments) {
                            if (assignment.deadlines > 0 && !hasDeadlines) {
                                hasDeadlines = true;
                            }

                            if (assignment.in_progress && !hasAssignmentInProgress) {
                                hasAssignmentInProgress = true;
                            }
                        }
                    }
                }
            }

            if (!this.roadmapIn && !hasDeadlines && !hasAssignmentInProgress) {
                return 1;
            }

            return 0;
        },
        resetUnreadMessages() {
            this.axios.delete(this.routes.portfolioDeleteUnreadMessage(this.projectIn.id)).then(
                (response) => {
                    this.count = 0;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updateTabIndex(tabIndex) {
            if (tabIndex === 3) {
                this.resetUnreadMessages();
            }

            if (tabIndex === 0) {
                CommonBus.$emit('initiate-slider');
            }

            this.activeTab = tabIndex;

            const name = 'portfolio-show-active-tab-' + this.projectIn.id;
            localStorage.setItem(name, tabIndex);
        },

        onOrder() {
            window.location.href = this.routes.paperOrder(this.project.id);
        },

        savePortfolioRating(values) {
            if (!values.rating.value && !values.rating.option_id && !this.portfolio.portfolio_rating.results.length) {
                return;
            }

            this.alert.saving();

            let data = values.rating;

            data.project_id = this.project.id;

            if (!this.portfolio.portfolio_rating.results.length) {
                this.axios.post(this.routes.portfolioRatingResult(), data).then(
                    (response) => {
                        this.portfolio.portfolio_rating.results = [response.data];
                        this.alert.success();
                        // this.fireClose(); todo
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            } else {
                this.axios.post(this.routes.portfolioRatingResultUpdate(), data).then(
                    (response) => {
                        if (response.data) {
                            this.portfolio.portfolio_rating.results = [response.data];
                        } else {
                            this.portfolio.portfolio_rating.results = [];
                        }

                        this.alert.success();
                        // if (!this.assignment.statuses || !this.assignment.statuses.length || this.assignment.statuses[0].status !== 1) {
                        //     this.fireClose();
                        // } else {
                        //     this.alert.success();
                        // } todo
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },

        shouldShowTab() {
            const hasRating = this.hasRatingResult && this.activeTab === 1;
            const hasMultipleProjects = !this.$authUser.isStudent();
            const isPortfolioRated =
                this.projectIn.type_id === 2 && this.activeTab === 1 && this.portfolio.portfolio_rating;
            const canRateProject = this.canRate && this.projectIn.type_id !== 2;
            const canEditProjectTitle = this.canEditTitle && this.projectIn.type_id !== 2;

            return hasRating || hasMultipleProjects || isPortfolioRated || canRateProject || canEditProjectTitle;
        },
    },

    created() {
        this.count = isNaN(this.projectIn.messages_count) ? this.count : this.count + this.projectIn.messages_count;
        const name = 'portfolio-show-active-tab-' + this.projectIn.id;

        if (this.portfolioIn.categories.every((category) => category.id !== this.categoryId)) {
            if (this.portfolioIn.categories.length > 0) {
                this.categoryId = this.portfolioIn.categories[0].id;
            }
        }

        if (this.categoryIdIn) {
            this.activeTab = 1;
            localStorage.setItem(name, this.activeTab);
        } else {
            if (localStorage.getItem(name)) {
                this.activeTab = parseInt(localStorage.getItem(name));
            }
        }

        if (this.activeTab === 0) {
            this.activeTab = this.getActiveTab();
        }
    },
    computed: {
        canRate() {
            if (!this.portfolio) {
                return false;
            }
            return (
                !this.$authUser.isStudent() && this.portfolio.portfolio_rating && this.portfolio.portfolio_rating.type
            );
        },

        hasRatingResult() {
            if (!this.portfolio) {
                return false;
            }
            return this.portfolio.portfolio_rating && this.portfolio.portfolio_rating.results.length;
        },

        getResultValue() {
            if (!this.portfolio) {
                return null;
            }

            if (!this.portfolio.portfolio_rating || !this.portfolio.portfolio_rating.results.length) {
                return null;
            }

            if (this.portfolio.portfolio_rating.type === 1) {
                const id = this.portfolio.portfolio_rating.results[0].portfolio_rating_option_id;
                for (const option of this.portfolio.portfolio_rating.options) {
                    if (option.id === id) {
                        return option.value;
                    }
                }
            }

            if (this.portfolio.portfolio_rating.type === 2) {
                return this.portfolio.portfolio_rating.results[0].value;
            }

            return null;
        },
    },
};
</script>

<style scoped lang="scss">
.portfolio-show-tab-header {
    align-self: center;
}

.btn-rate-portfolio-show {
    font-size: 1.125rem;
    height: 37px;

    &:before {
        margin-right: 0;
    }
}

.portfolio-rating {
    font-size: 1.125rem;
    padding-top: map-get($grid-gutter-spacing, 'eight');
    padding-bottom: map-get($grid-gutter-spacing, 'eight');
    height: 37px;

    &,
    i {
        margin-right: map-get($grid-gutter-spacing, 'fifteen');
    }
}

.portfolio-show-nav ::v-deep {
    &.show {
        button.dropdown-toggle {
            background-color: var(--primary);
            color: $white;
        }
    }

    .dropdown-menu {
        border: 1px solid $border-color;

        li.btn-rate-portfolio,
        li.btn-portfolio-order {
            &:before {
                color: var(--primary);
            }
        }
    }
}
</style>
